var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{style:({'height': _vm.iframeHeight}),attrs:{"width":"100%","src":_vm.vimeoUrl(),"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }